import { version } from './version';

export const environment = {
  production: true,
  appVersionAddon: '',
  webappName: 'Straatbeeld Online Afvalkalender',
  api_endpoint: 'https://api.straatbeeld.online/',
  sentry: {
    dsn: 'https://3d5a9abaf13707b2fdd3209c7faf263c@o4507735602298880.ingest.de.sentry.io/4508732963094608',
    version: version
  }
};
